import { render, staticRenderFns } from "./IconDomain.vue?vue&type=template&id=844058d2"
import script from "./IconDomain.vue?vue&type=script&lang=js"
export * from "./IconDomain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports